export interface RedirectUri {
  id: string
  value: string
}

export const createRedirectUri = (value = ''): RedirectUri => ({ id: crypto.randomUUID(), value })

export const toRedirectUris = (values: string[]): RedirectUri[] => values.map((value) => createRedirectUri(value))
